export default "/images/98993745138d84eeee3217c60f3668b6.avif";